

































import { Component, Vue, Ref } from "vue-property-decorator";

@Component({
    components: {
        FormBase: () => import("../../elements/forms/Base.vue"),
        FormInput: () => import("../../elements/forms/Input.vue"),
        ElSelect: () => import("../../elements/forms/select.vue"),
        ElPriceSelect: () => import("../../elements/forms/price-select.vue")
    }
})
export default class EstateSearchForm extends Vue {
    @Ref() readonly estateSearchForm!: FormClass;

    payload: SweepbrightSearch = {
        region: "",
        type: "",
        sale_or_let: "",
        price: "",
        extra_info: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        allow_newsletter: false
    };

    accepted_terms: boolean = false;

    typeOptions: SelectOption[] = [
        { value: "house", label: "Woning" },
        { value: "apartment", label: "Appartement" },
        { value: "parking", label: "Parking" },
        { value: "land", label: "Grond" },
        { value: "office", label: "Kantoor" }
    ];

    saleOrLetOptions: SelectOption[] = [
        { value: "sale", label: "Kopen" },
        { value: "let", label: "Huren" }
    ];

    private submitForm() {
        // @ts-ignore
        axios
            .post("/api/forms/estate-search", this.payload)
            .then((response: any) => {
                this.payload = {
                    region: "",
                    type: "",
                    sale_or_let: "",
                    price: "",
                    extra_info: "",
                    first_name: "",
                    last_name: "",
                    phone: "",
                    email: "",
                    allow_newsletter: false
                };

                this.accepted_terms = false;

                this.estateSearchForm.handleSuccess();
                this.estateSearchForm.reset();
            })
            .catch((e: any) => this.estateSearchForm.handleErrors(e.response.data));
    }
}
